/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ControlsDefinitionContent {
    getFixupPrototypeFunction() { return ControlsDefinitionContent.fixupPrototype; }

    static newInstance(model: Partial<ControlsDefinitionContent>): ControlsDefinitionContent {
        let obj = Object.assign(new ControlsDefinitionContent(), model);
        ControlsDefinitionContent.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ControlsDefinitionContent>): ControlsDefinitionContent {
        if (!model) return null;
        return ControlsDefinitionContent.newInstance(<ControlsDefinitionContent> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ControlsDefinitionContent) {
        if (!obj) return;

        models.ControlsDefinitionContent.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ControlsDefinitionContent): boolean {
        Object.setPrototypeOf(obj, ControlsDefinitionContent.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the CSV/XLSX file (e.g., controls.csv)
     */
    filename: string;

    /**
     * Base64-encoded file content
     */
    content: string;

}
